"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3928],{

/***/ 62790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);

const Divider = ({ className  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `w-full border-b border-neutral20_to_dark30 ${className ? className : ""}`
    });
};


/***/ }),

/***/ 29128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(35824);
// EXTERNAL MODULE: ./src/components/Divider/Divider.tsx
var Divider = __webpack_require__(62790);
// EXTERNAL MODULE: ./src/components/Logo/index.tsx
var Logo = __webpack_require__(34631);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
;// CONCATENATED MODULE: ./src/data/locales/id/footer.json
var footer_namespaceObject = JSON.parse('{"x":[{"id":1,"label":"Eksplor Kursus","icon":null,"href":"/explore"},{"id":2,"label":"Learnext Business","icon":null,"href":"https://learnext.ai?utm_source=learnext&utm_medium=textlink-footer"}],"g":[{"id":1,"label":"Kebijakan Privasi","icon":null,"href":"/privacy-policy?hideHeader=false"},{"id":2,"label":"Syarat Ketentuan","icon":null,"href":"/terms-of-use?hideHeader=false"}]}');
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(56562);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Icon/IconSocial.tsx
var IconSocial = __webpack_require__(49765);
// EXTERNAL MODULE: ./src/components/PageHeader/systemStore.ts
var systemStore = __webpack_require__(96937);
;// CONCATENATED MODULE: ./src/components/Footer/index.tsx









const SocialMedia = [
    {
        href: "https://www.instagram.com/learnext.ai/",
        icon: "instagram"
    },
    {
        href: "https://www.linkedin.com/company/learnext-ai/mycompany/",
        icon: "linkedin-square"
    }
];
const GKStore = [
    {
        href: "https://play.google.com/store/apps/details?id=com.and.gokampus&hl=en",
        icon: "/images/icon-google-play.png"
    },
    {
        href: "https://apps.apple.com/id/app/gokampus/id1456702223?l=id",
        icon: "/images/icon-app-store.png"
    }
];
const Footer = ({})=>{
    const [products, setProducts] = (0,react.useState)(null);
    const [aboutUs, setAboutUs] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        setProducts(footer_namespaceObject.x);
        setAboutUs(footer_namespaceObject.g);
    }, []);
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
            classBackgroundFull: "bg-light_neutral10_to_dark_neutral50 !h-[308px] h-full md:flex items-center justify-center hidden",
            className: "flex",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col text-purple-60 m-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-4 gap-32",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                                            useWhite: theme == "dark"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-light",
                                        children: "Belajar online GRATIS Sertifikat resmi dari institusi terpercaya untuk generasi muda Indonesia, AI-powered Learning for Professionals with Learnext!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-12 pl-[5rem]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-bold",
                                        children: "Produk"
                                    }),
                                    products && products.length && products.map((product)=>//@ts-ignore
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: product.href ? product.href : "#",
                                            target: "__blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-light",
                                                children: product.label
                                            })
                                        }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-12 pl-[1rem]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-bold",
                                        children: "Tentang Learnext"
                                    }),
                                    aboutUs && aboutUs.length && aboutUs.map((about)=>//@ts-ignore
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: about.href || "#",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-light",
                                                children: about.label
                                            })
                                        }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-bold",
                                        children: "Download Aplikasi Learnext"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grid grid-cols-2 gap-12",
                                        children: GKStore.map((store, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: store.href,
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: store.icon,
                                                    alt: "Store-" + i,
                                                    className: "w-full"
                                                })
                                            }))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                        className: "my-24 border-purple-30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-light text-b1",
                                children: "\xa9 2025 PT. Sistem Sarjana Sejahtera."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex gap-12",
                                children: SocialMedia.map((socmed)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: socmed.href,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSocial/* IconSocial */.K, {
                                            icon: socmed.icon,
                                            theme: "rounded-full"
                                        })
                                    }))
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_Footer = (Footer);


/***/ }),

/***/ 49765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ IconSocial; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);


const IconSocial = ({ theme ="rounded-6" , icon ="link"  })=>{
    const ICONS = {
        link: {
            image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "17",
                height: "18",
                viewBox: "0 0 17 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M14.7992 6.85801C14.7919 6.7937 14.7779 6.73035 14.7572 6.66901V6.60601C14.7236 6.53403 14.6787 6.46787 14.6242 6.41001L10.4242 2.21C10.3664 2.15555 10.3002 2.11066 10.2282 2.077C10.2073 2.07403 10.1861 2.07403 10.1652 2.077C10.0941 2.03622 10.0156 2.01004 9.93423 2H7.09922C6.54227 2 6.00812 2.22125 5.6143 2.61508C5.22047 3.0089 4.99922 3.54305 4.99922 4.1V4.8H4.29922C3.74227 4.8 3.20812 5.02125 2.8143 5.41508C2.42047 5.80891 2.19922 6.34305 2.19922 6.90001V13.9C2.19922 14.457 2.42047 14.9911 2.8143 15.3849C3.20812 15.7788 3.74227 16 4.29922 16H9.89923C10.4562 16 10.9903 15.7788 11.3842 15.3849C11.778 14.9911 11.9992 14.457 11.9992 13.9V13.2H12.6992C13.2562 13.2 13.7903 12.9788 14.1842 12.5849C14.578 12.1911 14.7992 11.657 14.7992 11.1V6.90001C14.7992 6.90001 14.7992 6.90001 14.7992 6.85801ZM10.5992 4.387L12.4122 6.20001H11.2992C11.1136 6.20001 10.9355 6.12626 10.8043 5.99498C10.673 5.8637 10.5992 5.68566 10.5992 5.5V4.387ZM10.5992 13.9C10.5992 14.0857 10.5255 14.2637 10.3942 14.395C10.2629 14.5263 10.0849 14.6 9.89923 14.6H4.29922C4.11357 14.6 3.93552 14.5263 3.80425 14.395C3.67297 14.2637 3.59922 14.0857 3.59922 13.9V6.90001C3.59922 6.71435 3.67297 6.53631 3.80425 6.40503C3.93552 6.27376 4.11357 6.20001 4.29922 6.20001H4.99922V11.1C4.99922 11.657 5.22047 12.1911 5.6143 12.5849C6.00812 12.9788 6.54227 13.2 7.09922 13.2H10.5992V13.9ZM13.3992 11.1C13.3992 11.2857 13.3255 11.4637 13.1942 11.595C13.0629 11.7263 12.8849 11.8 12.6992 11.8H7.09922C6.91357 11.8 6.73552 11.7263 6.60425 11.595C6.47297 11.4637 6.39922 11.2857 6.39922 11.1V4.1C6.39922 3.91435 6.47297 3.7363 6.60425 3.60503C6.73552 3.47375 6.91357 3.4 7.09922 3.4H9.19923V5.5C9.19923 6.05696 9.42048 6.5911 9.8143 6.98493C10.2081 7.37876 10.7423 7.60001 11.2992 7.60001H13.3992V11.1Z",
                    fill: "white"
                })
            }),
            color: "bg-violet_main_to_dark_purple_surface"
        },
        fb: {
            image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "17",
                height: "18",
                viewBox: "0 0 17 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9.8922 10.0461H11.6422L12.3422 7.24609H9.8922V5.84609C9.8922 5.12509 9.8922 4.44609 11.2922 4.44609H12.3422V2.09409C12.114 2.06399 11.2523 1.99609 10.3423 1.99609C8.44179 1.99609 7.09219 3.15599 7.09219 5.28609V7.24609H4.99219V10.0461H7.09219V15.9961H9.8922V10.0461Z",
                    fill: "white"
                })
            }),
            color: "bg-blue-05"
        },
        wa: {
            image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "17",
                height: "18",
                viewBox: "0 0 17 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M13.4313 4.02923C12.7895 3.38098 12.0251 2.867 11.1826 2.51726C10.3401 2.16753 9.43645 1.98905 8.52426 1.99223C4.70226 1.99223 1.58725 5.10723 1.58725 8.92923C1.58725 10.1542 1.90925 11.3442 2.51125 12.3942L1.53125 15.9922L5.20626 15.0262C6.22126 15.5792 7.36226 15.8732 8.52426 15.8732C12.3463 15.8732 15.4613 12.7582 15.4613 8.93623C15.4613 7.08123 14.7403 5.33823 13.4313 4.02923ZM8.52426 14.6972C7.48826 14.6972 6.47326 14.4172 5.58426 13.8922L5.37426 13.7662L3.19025 14.3402L3.77125 12.2122L3.63125 11.9952C3.05567 11.0761 2.75005 10.0137 2.74925 8.92923C2.74925 5.75123 5.33926 3.16123 8.51726 3.16123C10.0573 3.16123 11.5063 3.76323 12.5913 4.85523C13.1285 5.39 13.5543 6.02609 13.8438 6.72663C14.1334 7.42716 14.2811 8.17821 14.2783 8.93623C14.2923 12.1142 11.7023 14.6972 8.52426 14.6972ZM11.6883 10.3852C11.5133 10.3012 10.6593 9.88123 10.5053 9.81823C10.3443 9.76223 10.2323 9.73423 10.1133 9.90223C9.99426 10.0772 9.66526 10.4692 9.56726 10.5812C9.46926 10.7002 9.36426 10.7142 9.18926 10.6232C9.01426 10.5392 8.45426 10.3502 7.79626 9.76223C7.27826 9.30023 6.93526 8.73323 6.83026 8.55823C6.73226 8.38323 6.81626 8.29223 6.90726 8.20123C6.98426 8.12423 7.08226 7.99823 7.16626 7.90023C7.25026 7.80223 7.28526 7.72523 7.34126 7.61323C7.39726 7.49423 7.36926 7.39623 7.32726 7.31223C7.28526 7.22823 6.93526 6.37423 6.79526 6.02423C6.65526 5.68823 6.50826 5.73023 6.40326 5.72323H6.06726C5.94826 5.72323 5.76626 5.76523 5.60526 5.94023C5.45126 6.11523 5.00326 6.53523 5.00326 7.38923C5.00326 8.24323 5.62626 9.06923 5.71026 9.18123C5.79426 9.30023 6.93526 11.0502 8.67126 11.7992C9.08426 11.9812 9.40626 12.0862 9.65826 12.1632C10.0713 12.2962 10.4493 12.2752 10.7503 12.2332C11.0863 12.1842 11.7793 11.8132 11.9193 11.4072C12.0663 11.0012 12.0663 10.6582 12.0173 10.5812C11.9683 10.5042 11.8633 10.4692 11.6883 10.3852Z",
                    fill: "white"
                })
            }),
            color: "bg-green-05"
        },
        twitter: {
            image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "17",
                height: "18",
                viewBox: "0 0 17 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.8159 4.79648C15.2769 5.04148 14.6959 5.20248 14.0939 5.27948C14.7099 4.90848 15.1859 4.32048 15.4099 3.61348C14.8289 3.96348 14.1849 4.20848 13.5059 4.34848C12.9529 3.74648 12.1759 3.39648 11.2939 3.39648C9.64889 3.39648 8.30489 4.74048 8.30489 6.39948C8.30489 6.63748 8.33289 6.86848 8.38189 7.08548C5.88988 6.95948 3.67088 5.76248 2.19388 3.94948C1.93488 4.39048 1.78788 4.90848 1.78788 5.45448C1.78788 6.49748 2.31288 7.42148 3.12488 7.94648C2.62788 7.94648 2.16588 7.80648 1.75988 7.59648V7.61748C1.75988 9.07348 2.79588 10.2915 4.16788 10.5645C3.72739 10.685 3.26495 10.7018 2.81688 10.6135C3.007 11.2102 3.37936 11.7324 3.88159 12.1065C4.38383 12.4807 4.9907 12.6881 5.61688 12.6995C4.55542 13.5398 3.23968 13.994 1.88588 13.9875C1.64788 13.9875 1.40988 13.9735 1.17188 13.9455C2.50188 14.7995 4.08388 15.2965 5.77788 15.2965C11.2939 15.2965 14.3249 10.7185 14.3249 6.74948C14.3249 6.61648 14.3249 6.49048 14.3179 6.35748C14.9059 5.93748 15.4099 5.40548 15.8159 4.79648Z",
                    fill: "white"
                })
            }),
            color: "bg-blue-02"
        },
        linkedin: {
            image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "17",
                height: "18",
                viewBox: "0 0 17 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.95235 4.09211C4.95216 4.46341 4.80449 4.81943 4.5418 5.08185C4.27912 5.34427 3.92295 5.49159 3.55165 5.49141C3.18034 5.49122 2.82432 5.34354 2.5619 5.08086C2.29948 4.81818 2.15216 4.46201 2.15234 4.09071C2.15253 3.7194 2.30021 3.36338 2.56289 3.10096C2.82557 2.83854 3.18174 2.69122 3.55305 2.69141C3.92435 2.69159 4.28037 2.83927 4.54279 3.10195C4.80521 3.36463 4.95254 3.7208 4.95235 4.09211ZM4.99435 6.52811H2.19434V15.2921H4.99435V6.52811ZM9.41836 6.52811H6.63235V15.2921H9.39036V10.6931C9.39036 8.13111 12.7294 7.89311 12.7294 10.6931V15.2921H15.4944V9.74111C15.4944 5.42211 10.5524 5.58311 9.39036 7.70411L9.41836 6.52811Z",
                    fill: "white"
                })
            }),
            color: "bg-blue-04"
        },
        instagram: {
            image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M14.4503 4.54935C14.2525 4.54935 14.0592 4.608 13.8948 4.71788C13.7303 4.82776 13.6021 4.98394 13.5264 5.16667C13.4508 5.34939 13.431 5.55046 13.4695 5.74444C13.5081 5.93842 13.6034 6.1166 13.7432 6.25646C13.8831 6.39631 14.0613 6.49155 14.2552 6.53013C14.4492 6.56872 14.6503 6.54892 14.833 6.47323C15.0157 6.39754 15.1719 6.26937 15.2818 6.10492C15.3917 5.94047 15.4503 5.74713 15.4503 5.54935C15.4503 5.28413 15.345 5.02978 15.1574 4.84224C14.9699 4.65471 14.7155 4.54935 14.4503 4.54935ZM18.2837 6.56602C18.2675 5.8746 18.138 5.19052 17.9003 4.54102C17.6884 3.98529 17.3586 3.48208 16.9337 3.06602C16.521 2.63887 16.0166 2.31116 15.4587 2.10768C14.8109 1.86282 14.126 1.73036 13.4337 1.71602C12.5503 1.66602 12.267 1.66602 10.0003 1.66602C7.73366 1.66602 7.45033 1.66602 6.56699 1.71602C5.87462 1.73036 5.18978 1.86282 4.54199 2.10768C3.98506 2.31322 3.4811 2.64065 3.06699 3.06602C2.63985 3.47866 2.31214 3.98305 2.10866 4.54102C1.86379 5.1888 1.73133 5.87364 1.71699 6.56602C1.66699 7.44935 1.66699 7.73268 1.66699 9.99935C1.66699 12.266 1.66699 12.5493 1.71699 13.4327C1.73133 14.1251 1.86379 14.8099 2.10866 15.4577C2.31214 16.0156 2.63985 16.52 3.06699 16.9327C3.4811 17.358 3.98506 17.6855 4.54199 17.891C5.18978 18.1359 5.87462 18.2683 6.56699 18.2827C7.45033 18.3327 7.73366 18.3327 10.0003 18.3327C12.267 18.3327 12.5503 18.3327 13.4337 18.2827C14.126 18.2683 14.8109 18.1359 15.4587 17.891C16.0166 17.6875 16.521 17.3598 16.9337 16.9327C17.3605 16.5182 17.6906 16.0145 17.9003 15.4577C18.138 14.8082 18.2675 14.1241 18.2837 13.4327C18.2837 12.5493 18.3337 12.266 18.3337 9.99935C18.3337 7.73268 18.3337 7.44935 18.2837 6.56602ZM16.7837 13.3327C16.7776 13.8617 16.6818 14.3858 16.5003 14.8827C16.3673 15.2453 16.1536 15.573 15.8753 15.841C15.605 16.1164 15.278 16.3297 14.917 16.466C14.4201 16.6475 13.896 16.7433 13.367 16.7493C12.5337 16.791 12.2253 16.7993 10.0337 16.7993C7.84199 16.7993 7.53366 16.7993 6.70033 16.7493C6.15107 16.7596 5.60415 16.6751 5.08366 16.4993C4.73848 16.3561 4.42646 16.1433 4.16699 15.8743C3.8904 15.6066 3.67936 15.2787 3.55033 14.916C3.34687 14.412 3.23403 13.876 3.21699 13.3327C3.21699 12.4993 3.16699 12.191 3.16699 9.99935C3.16699 7.80768 3.16699 7.49935 3.21699 6.66602C3.22073 6.12523 3.31945 5.5893 3.50866 5.08268C3.65536 4.73094 3.88055 4.4174 4.16699 4.16602C4.42017 3.87949 4.73307 3.65193 5.08366 3.49935C5.59162 3.31605 6.12699 3.22025 6.66699 3.21602C7.50033 3.21602 7.80866 3.16602 10.0003 3.16602C12.192 3.16602 12.5003 3.16602 13.3337 3.21602C13.8626 3.22208 14.3867 3.31789 14.8837 3.49935C15.2624 3.63989 15.6022 3.86839 15.8753 4.16602C16.1484 4.422 16.3618 4.73496 16.5003 5.08268C16.6855 5.59013 16.7814 6.12583 16.7837 6.66602C16.8253 7.49935 16.8337 7.80768 16.8337 9.99935C16.8337 12.191 16.8253 12.4993 16.7837 13.3327ZM10.0003 5.72435C9.15517 5.726 8.32946 5.97812 7.62754 6.44886C6.92561 6.91961 6.37897 7.58785 6.05669 8.36914C5.7344 9.15044 5.65093 10.0097 5.81682 10.8385C5.98271 11.6672 6.39052 12.4281 6.98872 13.0252C7.58692 13.6222 8.34867 14.0285 9.17771 14.1928C10.0067 14.3571 10.8659 14.2719 11.6466 13.9481C12.4272 13.6243 13.0944 13.0764 13.5638 12.3735C14.0331 11.6707 14.2837 10.8445 14.2837 9.99935C14.2848 9.43694 14.1747 8.87985 13.9597 8.36015C13.7447 7.84044 13.4291 7.36836 13.0311 6.97106C12.633 6.57376 12.1603 6.25908 11.6402 6.04512C11.12 5.83117 10.5627 5.72215 10.0003 5.72435ZM10.0003 12.7743C9.45148 12.7743 8.91496 12.6116 8.45862 12.3067C8.00227 12.0018 7.64659 11.5684 7.43656 11.0613C7.22653 10.5542 7.17157 9.99627 7.27865 9.45797C7.38572 8.91968 7.65001 8.42522 8.0381 8.03713C8.4262 7.64904 8.92065 7.38474 9.45895 7.27767C9.99725 7.1706 10.5552 7.22555 11.0623 7.43558C11.5693 7.64562 12.0027 8.0013 12.3077 8.45764C12.6126 8.91399 12.7753 9.45051 12.7753 9.99935C12.7753 10.3638 12.7035 10.7246 12.5641 11.0613C12.4246 11.398 12.2202 11.7039 11.9625 11.9616C11.7049 12.2193 11.399 12.4237 11.0623 12.5631C10.7256 12.7026 10.3647 12.7743 10.0003 12.7743Z",
                    fill: "white"
                })
            }),
            color: "bg-purple-60"
        },
        "linkedin-square": {
            image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.0585 1.66613H2.9418C2.78311 1.66393 2.62555 1.69301 2.4781 1.7517C2.33066 1.8104 2.19622 1.89757 2.08246 2.00823C1.96871 2.11888 1.87786 2.25087 1.81512 2.39664C1.75238 2.54241 1.71897 2.69911 1.7168 2.8578V17.1411C1.71897 17.2998 1.75238 17.4565 1.81512 17.6023C1.87786 17.7481 1.96871 17.88 2.08246 17.9907C2.19622 18.1014 2.33066 18.1885 2.4781 18.2472C2.62555 18.3059 2.78311 18.335 2.9418 18.3328H17.0585C17.2171 18.335 17.3747 18.3059 17.5222 18.2472C17.6696 18.1885 17.804 18.1014 17.9178 17.9907C18.0316 17.88 18.1224 17.7481 18.1851 17.6023C18.2479 17.4565 18.2813 17.2998 18.2835 17.1411V2.8578C18.2813 2.69911 18.2479 2.54241 18.1851 2.39664C18.1224 2.25087 18.0316 2.11888 17.9178 2.00823C17.804 1.89757 17.6696 1.8104 17.5222 1.7517C17.3747 1.69301 17.2171 1.66393 17.0585 1.66613ZM6.7418 15.6161H4.2418V8.11613H6.7418V15.6161ZM5.4918 7.06613C5.14702 7.06613 4.81636 6.92917 4.57256 6.68537C4.32876 6.44157 4.1918 6.11091 4.1918 5.76613C4.1918 5.42135 4.32876 5.09069 4.57256 4.84689C4.81636 4.6031 5.14702 4.46613 5.4918 4.46613C5.67488 4.44537 5.86028 4.46351 6.03586 4.51937C6.21144 4.57523 6.37325 4.66754 6.51068 4.79027C6.64811 4.91299 6.75807 5.06336 6.83336 5.23153C6.90864 5.3997 6.94756 5.58188 6.94756 5.76613C6.94756 5.95039 6.90864 6.13256 6.83336 6.30073C6.75807 6.4689 6.64811 6.61927 6.51068 6.742C6.37325 6.86472 6.21144 6.95704 6.03586 7.0129C5.86028 7.06875 5.67488 7.08689 5.4918 7.06613ZM15.7585 15.6161H13.2585V11.5911C13.2585 10.5828 12.9001 9.92447 11.9918 9.92447C11.7107 9.92652 11.437 10.0147 11.2075 10.1771C10.978 10.3395 10.8039 10.5684 10.7085 10.8328C10.6433 11.0287 10.615 11.2349 10.6251 11.4411V15.6078H8.12513C8.12513 15.6078 8.12513 8.79113 8.12513 8.1078H10.6251V9.16613C10.8522 8.77205 11.1826 8.4474 11.5805 8.22713C11.9784 8.00687 12.4289 7.89934 12.8835 7.91613C14.5501 7.91613 15.7585 8.99113 15.7585 11.2995V15.6161Z",
                    fill: "white"
                })
            }),
            color: "bg-purple-60"
        },
        gmail: {
            image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "19",
                viewBox: "0 0 24 19",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        "clip-path": "url(#clip0_5718_17906)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M5.45456 18.0047V8.73187L2.57878 6.10096L0 4.64099V16.3683C0 17.2737 0.733594 18.0047 1.63641 18.0047H5.45456Z",
                                fill: "#4285F4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M18.5449 18.0047H22.3631C23.2686 18.0047 23.9995 17.271 23.9995 16.3683V4.64108L21.0786 6.3133L18.5449 8.73186V18.0047Z",
                                fill: "#34A853"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M5.45381 8.73187L5.0625 5.10871L5.45381 1.64099L11.9993 6.55012L18.5447 1.64099L18.9824 4.92149L18.5447 8.73187L11.9993 13.641L5.45381 8.73187Z",
                                fill: "#EA4335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M18.5449 1.641V8.73188L23.9995 4.641V2.45916C23.9995 0.435564 21.6895 -0.71803 20.0723 0.495564L18.5449 1.641Z",
                                fill: "#FBBC04"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M0 4.64101L2.50866 6.52258L5.45456 8.73189V1.64101L3.92719 0.495577C2.30719 -0.718111 0 0.435576 0 2.45908V4.64092V4.64101Z",
                                fill: "#C5221F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                            id: "clip0_5718_17906",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "24",
                                height: "18.0938",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            color: "bg-light_neutral10_to_dark_neutral50"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `p-8 flex justify-center items-center m-auto ${theme} ${ICONS[icon]["color"]}`,
        children: ICONS[icon]["image"]
    });
};


/***/ }),

/***/ 12582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jy": function() { return /* binding */ ArrayObjectSortBy; },
/* harmony export */   "zp": function() { return /* binding */ ReduceArrayFromDuplicate; }
/* harmony export */ });
/* unused harmony exports ObjectDeepMerge, ObjectOmit, parseDataParams, ShuffleArray, FilteredKeys */
// Merge a `source` object to a `target` recursively
const ObjectDeepMerge = (target, source)=>{
    // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
    for (const key of Object.keys(source)){
        if (source[key] instanceof Object) Object.assign(source[key], ObjectDeepMerge(target[key], source[key]));
    }
    // Join `target` and modified `source`
    Object.assign(target || {}, source);
    return target;
};
// omit keys from object
const ObjectOmit = (obj, keys)=>{
    const result = {
        ...obj
    };
    keys.forEach(function(prop) {
        delete result[prop];
    });
    return result;
};
// sort array of object by key
const ArrayObjectSortBy = (array, key, isDesc)=>{
    if (array) {
        return array.sort(function(a, b) {
            if (isDesc) {
                if (key == "created_date") {
                    //@ts-ignore
                    return new Date(b[key]) - new Date(a[key]);
                } else {
                    return b[key] - a[key];
                }
            } else {
                return a[key] - b[key];
            }
        });
    } else {
        return array;
    }
};
// reduce array with same objects
const ReduceArrayFromDuplicate = (items)=>{
    const filteredOption2 = Object.values(items.reduce((acc, cur)=>Object.assign(acc, {
            [cur.id]: cur
        }), {}));
    return filteredOption2;
};
// generate object when not null
const parseDataParams = (params)=>{
    let newParams = {};
    for (let [k, v] of Object.entries(params)){
        if (v) {
            newParams[k] = v;
        }
    }
    return newParams;
};
// suffle an array
const ShuffleArray = (array)=>{
    let currentIndex = array.length, randomIndex;
    // While there remain elements to shuffle.
    while(currentIndex > 0){
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
    return array;
};
// example raw: ["a","b"], obj: {"a" : "aaa", "b" : "bbb", "c": "ccc"}
const FilteredKeys = (raw, obj)=>{
    const filtered = Object.keys(obj).filter((key)=>raw.includes(key)).reduce((obj, key)=>{
        obj[key] = raw[key];
        return obj;
    }, {});
    return filtered;
};


/***/ }),

/***/ 86036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DU": function() { return /* binding */ getPrevLesson; },
/* harmony export */   "Kt": function() { return /* binding */ useCourseStore; },
/* harmony export */   "OA": function() { return /* binding */ getLessonNumberBySlug; },
/* harmony export */   "P_": function() { return /* binding */ getLessonIdBySlug; },
/* harmony export */   "Qm": function() { return /* binding */ getFirstUnfinishedLesson; },
/* harmony export */   "bR": function() { return /* binding */ getChapter; },
/* harmony export */   "cW": function() { return /* binding */ isHasWebinar; },
/* harmony export */   "tm": function() { return /* binding */ getNextLesson; }
/* harmony export */ });
/* unused harmony export courseTabItems */
/* harmony import */ var lib_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12582);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);


const courseTabItems = [
    "Konten Kelas",
    "Overview",
    "Rekomendasi Kursus Lainnya"
];
const useCourseStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        // state
        currentTab: courseTabItems[0],
        isLessonLoading: false,
        currentLesson: null,
        isPaywallShown: false,
        isLock: false,
        isNextLock: false,
        courseStatus: null,
        courseEnrollmentId: null,
        currentBundle: null,
        allCourse: null,
        currentCourse: null,
        showBundlePaywall: false,
        showSuccesBundle: false,
        showModalReview: false,
        bundleEnrollmentId: "",
        mandatoryCount: 0,
        showModalSubscribeBusiness: false,
        showModalSubscribeBusinessHR: false,
        showModalQuiz: false,
        learnSessionToken: "",
        tabId: "",
        courseSession: null,
        // actions
        setCurrentTab (tab) {
            set({
                currentTab: tab
            });
        },
        setPaywallShown (b) {
            set({
                isPaywallShown: b
            });
        },
        setLock (b) {
            set({
                isLock: b
            });
        },
        setNextLock (b) {
            set({
                isNextLock: b
            });
        },
        setLessonLoading (isLoading = false) {
            set({
                isLessonLoading: isLoading
            });
        },
        setCurrentLesson (lesson) {
            set({
                currentLesson: lesson
            });
        },
        setAllCourse (course) {
            set({
                allCourse: course
            });
        },
        setCurrentCourse (course) {
            set({
                currentCourse: course
            });
        },
        setCourseStatus (courseStatus) {
            set({
                courseStatus: courseStatus
            });
        },
        setCourseEnrollmentId (id) {
            set({
                courseEnrollmentId: id
            });
        },
        setBundleEnrollmentId (id) {
            set({
                bundleEnrollmentId: id
            });
        },
        setBundle (currentBundle) {
            set({
                currentBundle
            });
        },
        setShowBundlePaywall (showBundlePaywall) {
            set({
                showBundlePaywall
            });
        },
        setShowSuccesBundle (showSuccesBundle) {
            set({
                showSuccesBundle
            });
        },
        setShowModalReview (showModalReview) {
            set({
                showModalReview
            });
        },
        setMandatoryCount (count) {
            set({
                mandatoryCount: count
            });
        },
        setShowModalSubscribeBusiness (showModal) {
            set({
                showModalSubscribeBusiness: showModal
            });
        },
        setShowModalSubscribeBusinessHR (showModal) {
            set({
                showModalSubscribeBusinessHR: showModal
            });
        },
        setShowModalQuiz (showModal) {
            set({
                showModalQuiz: showModal
            });
        },
        setLearnSessionToken (token) {
            set({
                learnSessionToken: token
            });
        },
        setTabId (tabId) {
            set({
                tabId: tabId
            });
        },
        setCourseSession (session) {
            set({
                courseSession: session || null
            });
        }
    }));
const getChapter = (chapters, currentLessonSlug)=>{
    const chapter = chapters && chapters.length ? chapters.find((c)=>{
        const l = c.lessons?.find((l)=>l.slug == currentLessonSlug);
        return !!l;
    }) : [];
    return chapter;
};
const getNextLesson = (chapters, currentLessonSlug)=>{
    const sortedChapters = chapters && chapters.length ? (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(chapters, "number").map((c)=>{
        return {
            ...c,
            lessons: (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(c.lessons, "sort_order")
        };
    }) : [];
    let sortedLessons = [];
    sortedChapters.forEach((c)=>{
        c.lessons.forEach((l)=>sortedLessons.push({
                ...l,
                chapter: c.number
            }));
    });
    let nextLesson = null;
    for(let index = 0; index < sortedLessons.length - 1; index++){
        if (sortedLessons[index].slug == currentLessonSlug) {
            nextLesson = sortedLessons[index + 1];
            break;
        }
    }
    return nextLesson;
};
const getPrevLesson = (chapters, currentLessonSlug)=>{
    const sortedChapters = chapters && chapters.length ? (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(chapters, "number").map((c)=>{
        return {
            ...c,
            lessons: (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(c.lessons, "sort_order")
        };
    }) : [];
    let sortedLessons = [];
    sortedChapters.forEach((c)=>{
        c.lessons.forEach((l)=>sortedLessons.push({
                ...l,
                chapter: c.number
            }));
    });
    let prevLesson = null;
    for(let index = 1; index < sortedLessons.length; index++){
        if (sortedLessons[index].slug == currentLessonSlug) {
            prevLesson = sortedLessons[index - 1];
            break;
        }
    }
    return prevLesson;
};
const isHasWebinar = (chapters)=>{
    return chapters.some((c)=>c.lessons.some((l)=>l.type === "Webinar"));
};
const getFirstUnfinishedLesson = (courseStatus)=>{
    const sortedChapters = courseStatus.chapters && courseStatus.chapters.length ? (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(courseStatus.chapters, "number").map((c)=>{
        return {
            ...c,
            lessons: (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(c.lessons, "sort_order")
        };
    }) : [];
    let sortedLessons = [];
    sortedChapters.forEach((c)=>{
        c.lessons.forEach((l)=>sortedLessons.push({
                ...l
            }));
    });
    const unfinishedLesson = sortedLessons.find((l)=>l.progress[0]?.is_done == false);
    return unfinishedLesson;
};
// get lesson number from slug name
const getLessonNumberBySlug = (slug, courseStatus)=>{
    let allArray = [];
    if (courseStatus && courseStatus.chapters && courseStatus.chapters.length) {
        courseStatus.chapters.forEach((el)=>{
            el.lessons.forEach((a, i)=>{
                allArray.push({
                    number: el.number,
                    slug: a.slug
                });
            });
        });
    }
    if (allArray.length) {
        allArray = [
            ...allArray
        ].map((a, idx)=>{
            return {
                ...a,
                lesson_num: idx + 1
            };
        });
    }
    return allArray.find((a)=>a.slug == slug)?.lesson_num;
};
const getLessonIdBySlug = (chapters = [], slug)=>{
    // Iterate through the chapters array
    for (const chapter of chapters){
        // Iterate through the lessons in each chapter
        for (const lesson of chapter.lessons){
            // Check if the lesson's slug matches the given slug
            if (lesson.slug === slug) {
                // Return the ID of the matching lesson
                return {
                    lessonId: lesson.id,
                    chapterNum: chapter.number
                };
            }
        }
    }
    // If no matching lesson is found, return null or an appropriate value
    return null;
};


/***/ })

}]);